import React, { useState } from "react";
import {BrowserRouter as Router, useLocation, useNavigate} from "react-router-dom";
import { useVersionCheck } from '../common/hooks/useVersionCheck';
import {Auth} from '../common/AuthProvider';
import { HelmetProvider } from 'react-helmet-async';

import "./App.css";
import AdminRoutes from './AdminRoutes';

export const AuthContext = React.createContext(null);

const AuthContextProvider = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    
    const initialPublicPages = ["/login", "/signup", "/", ""]
    var isPublicPage = (initialPublicPages.indexOf(location.pathname) > -1);
    const [loggedIn, setLoggedIn] = useState(!isPublicPage);
    
    const [showBanner, setShowBanner] = useState(false);
    useVersionCheck(60000, () => setShowBanner(true));

    const handleLogin = async (email, password, onFailure) => {
        Auth.login({email: email, password: password})
            .then((response)=>{
                setLoggedIn(true);
                let areaLoginPath = '/dashboard';               
                
                const origin = location.state?.from?.pathname || areaLoginPath;
                navigate(origin);
            })
            .catch((err)=>{
                setLoggedIn(false);
                onFailure(err.response?.data?.message)
            })
    };

    const handleCsrfToken = async () => {
        try {
            await Auth.getCsrfToken();
        } catch (error) {
            console.error('Failed to get CSRF token:', error);
        }
    }

    const handleLogout = () => {
        Auth.logout().then(()=>{
            setLoggedIn(false);
            navigate('/login');
        }).catch((err)=>{
            console.log(err);
        })
    };

    const value = {
        loggedIn: loggedIn,
        onLoad: handleCsrfToken,
        onLogin: handleLogin,
        onLogout: handleLogout,
    };
    
    return (
        <>
            {showBanner && (
                <div style={{position: 'fixed', top: 0, width: '100%', background: '#ffc', color: '#333', zIndex: 9999, textAlign: 'center', padding: 10}}>
                    A new version is available. <button onClick={() => window.location.reload()}>Refresh</button>
                </div>
            )}
            <AuthContext.Provider value={value}>
                {children}
            </AuthContext.Provider>
        </>
    );
};

const AppContent = () => {
    return (
        <div className="[font-family:'Inter']">
            <AuthContextProvider>
                <AdminRoutes />
            </AuthContextProvider>
        </div>
    );
};

export default function App() {
    return (
        <HelmetProvider>
            <Router>
                <AppContent />
            </Router>
        </HelmetProvider>
    );
}
